export class ComponentData {
    component: any = null;
    componentInput: any = {};
    closeEvent: any = null;
}